import { render, staticRenderFns } from "./FertilizationTab.vue?vue&type=template&id=7b127be8&scoped=true&"
import script from "./FertilizationTab.vue?vue&type=script&lang=js&"
export * from "./FertilizationTab.vue?vue&type=script&lang=js&"
import style1 from "./FertilizationTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b127be8",
  null
  
)

export default component.exports